import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import CategoryDetails from "./routes/CategoryDetail";

export default store => ({
  path: "default-outcomes",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "behaviour-default-outcomes" */ "./components"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [CategoryDetails(store)],
});
